import { Outlet } from 'react-router';
import { ConnectionBanner } from '@/components/ConnectionBanner';
import { SideNav, SkipLink } from './nav';
import type { NavItem } from './nav';
import { StaffHeader } from './StaffHeader';

/** Tablet-landscape and desktop shell for kitchen, counter and admin: dark header, canvas workspace. */
export function OperationsShell({
  title,
  navItems = [],
  children,
}: {
  title: string;
  navItems?: NavItem[];
  children?: React.ReactNode;
}) {
  return (
    <div className="flex min-h-dvh flex-col bg-canvas">
      <SkipLink />
      <StaffHeader title={title} />
      <ConnectionBanner />
      <div className="flex flex-1">
        {navItems.length > 0 && (
          <aside className="hidden w-56 shrink-0 border-r border-line bg-white p-3 md:block">
            <SideNav items={navItems} label={`${title} navigation`} />
          </aside>
        )}
        <main id="main" tabIndex={-1} className="min-w-0 flex-1 px-4 py-4 md:px-6">
          {children ?? <Outlet />}
        </main>
      </div>
    </div>
  );
}
